<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({ fields: { type: Array, default: () => [] } });
const { t, locale } = useI18n();
const groups = computed(() => {
  const result = new Map();
  props.fields.forEach(field => {
    const name = field.group || t('BUSINESS.BASIC_GROUP');
    if (!result.has(name)) result.set(name, []);
    result.get(name).push(field);
  });
  return Array.from(result, ([name, fields]) => ({ name, fields }));
});
const format = field => {
  if (field.value === null || field.value === undefined)
    return t('BUSINESS.UNAVAILABLE');
  if (field.type === 'boolean')
    return t(field.value ? 'BUSINESS.YES' : 'BUSINESS.NO');
  try {
    if (field.type === 'money')
      return new Intl.NumberFormat(locale.value.replace('_', '-'), {
        style: 'currency',
        currency: field.currency || 'CNY',
      }).format(field.value);
    if (
      ['datetime', 'timestamp_seconds', 'timestamp_milliseconds'].includes(
        field.type
      )
    )
      return new Date(field.value).toLocaleString(
        locale.value.replace('_', '-')
      );
  } catch {
    return String(field.value);
  }
  return String(field.value);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <section v-for="group in groups" :key="group.name">
      <h4 class="text-sm font-medium text-n-slate-12 mb-2">{{ group.name }}</h4>
      <dl class="grid gap-2 text-sm">
        <div
          v-for="field in group.fields"
          :key="field.key"
          class="grid grid-cols-2 gap-2"
        >
          <dt class="text-n-slate-11 break-words">{{ field.label }}</dt>
          <dd class="text-n-slate-12 break-words whitespace-pre-wrap">
            {{ format(field) }}
          </dd>
        </div>
      </dl>
    </section>
  </div>
</template>
